const genderDisplayOptions = [
  { value: '0', label: 'Select', exp: 'Select' },
  { value: '1', label: 'Male' },
  { value: '2', label: 'Female'},
  { value: '3', label: 'Others'},
]

export default genderDisplayOptions
